module.exports = __webpack_public_path__ + "img/logo_negativ_ohne_website.da778d14.png";